export default __webpack_public_path__ + "static/media/fill8.a85291f8.svg";